var exports = {
  "Kk": "x9245d464--5e5ad0--icon",
  "GN": "x9245d464--5e5ad0--icon--inner",
  "YL": "x9245d464--5e5ad0--tooltip",
};

module.exports = exports;
